// Ref-counted body scroll lock. Replaces the scattered, conflicting
// `document.body.style.overflow` toggles across the modal layer.
//
// Why ref-counting: with stacked overlays (modal over modal, backdrop under a
// panel) the naive "set hidden on open / clear on close" breaks — closing the
// inner overlay would free page scroll while the outer one is still open. Here
// the first lock captures the original overflow and sets `hidden`; scroll is
// only restored when the LAST lock is released.

let lockCount = 0;
let previousOverflow: string | null = null;

/** Acquire a scroll lock. Safe to nest — only the first call mutates the body. */
export function lockBodyScroll(): void {
  if (lockCount === 0) {
    previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
  }
  lockCount += 1;
}

/** Release a scroll lock. Restores the original overflow once the count hits 0. */
export function unlockBodyScroll(): void {
  if (lockCount === 0) {
    return;
  }
  lockCount -= 1;
  if (lockCount === 0) {
    if (previousOverflow) {
      document.body.style.overflow = previousOverflow;
    } else {
      document.body.style.removeProperty('overflow');
    }
    previousOverflow = null;
  }
}
